export const font = {
    family: {
        typeface: '"sohne-var", "Helvetica Neue", "Arial", sans-serif'
    },
    weight: {
        light: '200',
        normal: '300',
        semibold: '425',
        bold: '500'
    },
    display: {
        // TODO: This is used to represent the section title when used on large viewport, let's update/review if we need to make this more global
        xlarge: {
            size: '56px',
            lineHeight: '68px',
            weight: '500'
        },
        // TODO: This is used to represent the hero title when used on large viewport, let's update/review if we need to make this more global
        large: {
            size: '38px',
            lineHeight: '48px',
            weight: '500'
        },
        // TODO: This is used to represent the subsection title when used on small viewport, let's update/review if we need to make this more global
        medium: {
            size: '26px',
            lineHeight: '36px',
            weight: '500'
        },
        small: {
            size: '18px',
            lineHeight: '28px',
            weight: '500'
        }
    },
    // Basing these on header elements h1, h2, h3, h4, h5 etc.
    heading: {
        xlarge: {
            size: '48px',
            lineHeight: '56px',
            weight: '500'
        },
        large: {
            size: '34px',
            lineHeight: '44px',
            weight: '500'
        },
        medium: {
            size: '24px',
            lineHeight: '32px',
            weight: '500'
        },
        small: {
            size: '15px',
            lineHeight: '24px',
            weight: '425'
        }
    },
    body: {
        large: {
            size: '18px',
            lineHeight: '28px',
            emphasized: {
                weight: '425'
            }
        },
        medium: {
            size: '15px',
            lineHeight: '24px',
            emphasized: {
                weight: '425'
            }
        },
        small: {
            size: '13px',
            lineHeight: '20px'
        }
    },
    label: {
        large: {
            size: '16px'
        },
        medium: {
            size: '15px'
        },
        small: {
            size: '13px',
            emphasized: {
                size: '13px'
            }
        }
    }
};
export const customLetterSpacingTokens = {
    xxsmall: '-0.02em',
    xsmall: '-0.2px',
    small: '-0.1px',
    medium: '0.1px',
    large: '0.2px'
};

//# sourceMappingURL=typography.js.map